import React, { useEffect, useState, useCallback } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Table,
  Input,
  Button,
  Spinner,
} from "reactstrap";
import axiosInstance from "../../axiosInstance";
import { URL } from "../../api.jsx";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const PAGE_SIZE = 10;

const PromiseToPay = () => {
  /* ================= STATES ================= */
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [customerId, setCustomerId] = useState("");
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(0);


  const fetchPromises = useCallback(async () => {
  try {
    setLoading(true);

    const callerId = localStorage.getItem("userId");
    const admin = localStorage.getItem("isAdmin");

    const res = await axiosInstance.get(URL.GET_PROMISE_TO_PAY, {
      params: {
        customerId: customerId || null,
        status: status || null,
        callerId: admin === "1" ? null : callerId,
        admin: admin === "1" ? 1 : 0,
      },
    });

    const result = res.data || [];   // ✅ ADD THIS LINE

    setData(result);                 // ✅ Now correct
    setPage(0);

  } catch (err) {
    console.error("Fetch failed", err);
    toast.error("Failed to fetch data");
  } finally {
    setLoading(false);
  }
}, [customerId, status]);


  // /* ================= FETCH DATA ================= */
  // const fetchPromises = useCallback(async () => {
  //   try {
  //     setLoading(true);

  //     const res = await axiosInstance.get(URL.GET_PROMISE_TO_PAY);
  //     let result = res.data || [];

  //     // Filter by customerId
  //     if (customerId) {
  //       result = result.filter(
  //         (item) => String(item.customerId) === String(customerId)
  //       );
  //     }

  //     // Filter by status
  //     if (status) {
  //       result = result.filter((item) => item.status === status);
  //     }

  //     setData(result);
  //     setPage(0);
  //   } catch (err) {
  //     console.error("Fetch failed", err);
  //     toast.error("Failed to fetch data");
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [customerId, status]);

  /* ================= STATUS UPDATE ================= */
  const handleStatusUpdate = async (item, newStatus) => {
    try {
      await axiosInstance.post(URL.STATUS_UPDATE_OF_PROMISE, null, {
        params: {
          promiseId: item.promiseId,
          customerId: item.customerId,
          status: newStatus,
        },
      });

      toast.success(`Status updated to ${newStatus}`);
      fetchPromises(); // refresh
    } catch (error) {
      console.error("Status update failed", error);
      toast.error("Failed to update status");
    }
  };

  /* ================= INIT ================= */
  useEffect(() => {
    fetchPromises();
  }, [fetchPromises]);

  /* ================= PAGINATION ================= */
  const totalPages = Math.ceil(data.length / PAGE_SIZE);

  const paginatedData = data.slice(
    page * PAGE_SIZE,
    page * PAGE_SIZE + PAGE_SIZE
  );

  /* ================= UI ================= */
  return (
    <>
      <ToastContainer position="top-right" autoClose={2000} />

      {/* PAGE TITLE */}
      <Row className="mb-2">
        <Col>
          <h4 className="page-title">Promise To Pay List</h4>
        </Col>
      </Row>

      {/* FILTER */}
      <Card className="mb-3 p-3">
        <div className="d-flex gap-2 align-items-end flex-wrap">

          <div>
            <label className="form-label mb-1">Customer ID</label>
            <Input
              bsSize="sm"
              value={customerId}
              onChange={(e) => setCustomerId(e.target.value)}
              placeholder="Enter Customer ID"
              style={{ width: 180 }}
            />
          </div>

          <div>
            <label className="form-label mb-1">Status</label>
            <Input
              type="select"
              bsSize="sm"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              style={{ width: 150 }}
            >
              <option value="">All</option>
              <option value="ACTIVE">ACTIVE</option>
              <option value="KEPT">KEPT</option>
              <option value="BROKEN">BROKEN</option>
            </Input>
          </div>

          <Button size="sm" color="info" onClick={fetchPromises}>
            Search
          </Button>

          <Button
            size="sm"
            color="secondary"
            onClick={() => {
              setCustomerId("");
              setStatus("");
              fetchPromises();
            }}
          >
            Reset
          </Button>
        </div>
      </Card>

      {/* TABLE */}
      <Card>
        <CardBody>
          {loading ? (
            <div className="text-center my-4">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <Table
                bordered
                hover
                size="sm"
                responsive
                className="text-nowrap"
              >
                <thead className="table-light">
                  <tr>
                    <th>Promise ID</th>
                    <th>Customer ID</th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Caller</th>
                    <th>Call Date</th>
                    <th>Promise Date</th>
                    <th>Amount</th>
                    <th>Payment Type</th>
                    <th>Status</th>
                    <th>Remarks</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedData.length === 0 ? (
                    <tr>
                      <td colSpan="12" className="text-center text-muted">
                        No records found
                      </td>
                    </tr>
                  ) : (
                    paginatedData.map((item) => (
                      <tr key={item.promiseId}>
                        <td>{item.promiseId}</td>
                        <td>{item.customerId}</td>
                        <td>{item.customerFullName || "-"}</td>
                        <td>{item.customerPhoneNumber}</td>
                        <td>{item.callerUserName}</td>
                        <td>{item.callDatetime}</td>
                        <td>{item.promisedPayDate}</td>
                        <td>₹ {item.promisedAmount}</td>
                        <td>{item.paymentType}</td>

                        <td>
                          <span
                            className={`badge ${
                              item.status === "ACTIVE"
                                ? "bg-primary"
                                : item.status === "KEPT"
                                ? "bg-success"
                                : "bg-danger"
                            }`}
                          >
                            {item.status}
                          </span>
                        </td>

                        <td>{item.remarks}</td>

                     <td>
                    {item.status === "ACTIVE" && (
                        <Input
                        type="select"
                        bsSize="sm"
                        style={{ width: 120 }}
                        defaultValue=""
                        onChange={(e) => {
                            const value = e.target.value;
                            if (value) {
                            handleStatusUpdate(item, value);
                            }
                        }}
                        >
                        <option value="">Update</option>
                        <option value="KEPT">KEPT</option>
                        <option value="BROKEN">BROKEN</option>
                        </Input>
                    )}
                    </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>

              {/* PAGINATION */}
              {totalPages > 1 && (
                <div className="d-flex justify-content-end align-items-center gap-2 mt-2">
                  <Button
                    size="sm"
                    disabled={page === 0}
                    onClick={() => setPage(page - 1)}
                  >
                    Prev
                  </Button>

                  <span className="text-muted">
                    Page {page + 1} of {totalPages}
                  </span>

                  <Button
                    size="sm"
                    disabled={page + 1 >= totalPages}
                    onClick={() => setPage(page + 1)}
                  >
                    Next
                  </Button>
                </div>
              )}
            </>
          )}
        </CardBody>
      </Card>
    </>
  );
};

export default PromiseToPay;
